export default "/images/add-new-image.8028a4.png";